import { render } from "./ManualClaimProductFields.vue?vue&type=template&id=119a61e0"
import script from "./ManualClaimProductFields.vue?vue&type=script&lang=js"
export * from "./ManualClaimProductFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__